const sensors = require('sa-sdk-javascript')
import { getRunPlatform, isPcApp } from '@/utils/runTimeEnv'
import { Version } from '../compareappver'

let server_url: string,
  show_log: boolean,
  sa_domin = ''
if (getRunPlatform() === 'H5') {
  sa_domin = '//pcsac.pc.com.cn/sa'
} else {
  if (Version('5.37.0', '')) {
    sa_domin = '//pcsac.pc.com.cn/sa'
  } else {
    sa_domin = '//samid.pc.com.cn/sa'
  }
}
if (process.env.VUE_APP_NODE_ENV === 'production') {
  // 生产环境
  server_url = window.location.protocol + sa_domin + '?project=production'
  show_log = false
} else {
  // 非生产环境
  server_url = window.location.protocol + sa_domin + '?project=pcautotest'
  show_log = true
}

sensors.init({
  server_url: server_url,
  show_log: show_log,
  // 配置打通 App 与 H5 的参数
  use_app_track: true,
  app_js_bridge: true,
})
// 注册公共属性
// sensors.registerPage({
//     current_url: window.location.href,
//     referrer: document.referrer
// });
// sensors.quick('autoTrack'); // 自动埋点
// console.log('sensors===================')
export default sensors
